import type { SxProps, Theme } from '@mui/material'

import { Box, Typography } from '@mui/material'

import { CalendarIcon, InfoCircleIcon, LockIcon } from '@/components/ui/icons'
import { formatDate } from '@/utils/datetime'

interface Props {
  enforcementDate?: string | null
}

interface Line {
  key: string
  icon: React.ReactNode
  text: React.ReactNode
}

const ICON_SX = { fontSize: 20, color: 'primary.main', mt: '1px' } satisfies SxProps<Theme>

// Signing in by email is the last place email still works, so this says why it is going and what to do next.
export function EmailSignInNotice({ enforcementDate }: Props) {
  const lines: Line[] = [
    {
      key: 'why',
      icon: <LockIcon sx={ICON_SX} />,
      text: (
        <>
          To keep your account safe, we're replacing email codes with an{' '}
          <strong>authenticator app, text or call</strong>.
        </>
      ),
    },
    ...(enforcementDate
      ? [
          {
            key: 'when',
            icon: <CalendarIcon sx={ICON_SX} />,
            text: (
              <>
                You can still use email until <strong>{formatDate(enforcementDate, 'MMMM D, YYYY')}</strong>.
              </>
            ),
          },
        ]
      : []),
    {
      key: 'next',
      icon: <InfoCircleIcon sx={ICON_SX} />,
      text: (
        <>
          After you sign in, switch your method from your <strong>profile menu</strong>.
        </>
      ),
    },
  ]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {lines.map((line) => (
        <Box key={line.key} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
          {line.icon}
          <Typography variant="body2">{line.text}</Typography>
        </Box>
      ))}
    </Box>
  )
}
